/* NervaraLab · Mobil-Menü: Icons und Bild-Karten aus dem Desktop-Megamenü übernehmen */
(() => {
  if (window.__nvMenuDecor) return; window.__nvMenuDecor = true;
  const norm = (t) => (t || '').replace(/[^0-9A-Za-zÄÖÜäöüß&]+/g, ' ').trim();
  const kind = (u) => {
    const k = (u || '').split('?')[0].split('/').pop();
    if (k === 'all') return 'all';
    if (k.indexOf('set') === 0) return 'sets';
    if (['kapseln', 'fruchtgummis', 'gummies', 'pulver', 'tabletten'].includes(k)) return 'form';
    if (['magnesium', 'zink', 'ashwagandha', 'multivitamin', 'kreatin', 'omega-3', 'eisen'].includes(k) || k.indexOf('vitamin') === 0) return 'wirk';
    return 'ziel';
  };
  const icon = (h) => { const d = document.querySelector('a.mega-menu__link[href="' + h + '"] .mega-icon'); if (!d) return null; const c = d.cloneNode(true); c.className = 'nvp__ic'; return c; };
  const DESC = {
    laboranalysen: 'Prüfberichte je Charge ansehen',
    reinheitsversprechen: 'Was nicht in unsere Produkte kommt',
    'gmp-standards': 'Hergestellt in der EU nach GMP',
    'chelat-technologie': 'Warum die Form eines Minerals zählt',
    nachhaltigkeit: 'Verpackung, Lieferkette, Verantwortung'
  };
  const secB = (title, items, mod) => {
    if (!items.length) return null;
    const li = document.createElement('li'); li.className = 'nvp__sec';
    if (title) { const h = document.createElement('p'); h.className = 'nvp__h'; h.textContent = title; li.appendChild(h); }
    const l = document.createElement('ul'); l.className = 'nvp__list nvp__list--' + mod; l.setAttribute('role', 'list');
    items.forEach((i) => l.appendChild(i));
    if (mod === 'tiles' && items.length % 2) items[items.length - 1].classList.add('nvp__it--wide');
    li.appendChild(l); return li;
  };
  const flat = (inner) => {
    const ul = inner.querySelector('.menu-drawer__menu--childlist');
    if (!ul || ul.dataset.nvflat) return;
    const lis = [...ul.children].filter((li) => li.tagName === 'LI');
    if (!lis.length || ul.querySelector('.menu-drawer__menu--grandchildlist')) return;
    ul.dataset.nvflat = '1'; ul.classList.add('nvp');
    /* Ratgeber: Gruppen, Icons und „Neu“-Badge aus dem Desktop-Megamenü (.nvrm) */
    const rg = document.querySelector('.nvrm');
    const hrefOf = (li) => { const a = li.querySelector('a'); return a ? a.getAttribute('href') : ''; };
    if (rg && lis.some((li) => hrefOf(li) === '/blogs/ratgeber')) {
      const by = {}; lis.forEach((li) => { by[hrefOf(li)] = li; });
      if (!document.getElementById('nvp-rg-css')) { const st = document.createElement('style'); st.id = 'nvp-rg-css'; st.textContent = '.nvp__new{display:inline-block;margin-left:6px;padding:1px 7px;border-radius:999px;background:#c9a24b;color:#1f3a2b;font-size:10.5px;font-style:normal;font-weight:800;line-height:1.5;vertical-align:middle}'; document.head.appendChild(st); }
      const BOOK = '<span class="nvp__ic"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5z"/><path d="M4 20.5A2.5 2.5 0 0 0 6.5 23H20v-5M8 7h8M8 11h6"/></svg></span>';
      const prep = (li, s) => {
        const a = li.querySelector('a'); li.classList.add('nvp__it'); a.classList.add('nvp__a');
        const i = s && s.querySelector('.nvrm__i');
        if (i) { const c = i.cloneNode(true); c.className = 'nvp__ic'; a.prepend(c); }
        const t = a.querySelector('.menu-drawer__menu-item-text');
        if (t && s && s.querySelector('.nvrm__new')) { const e = document.createElement('em'); e.className = 'nvp__new'; e.textContent = 'Neu'; t.appendChild(e); }
        return li;
      };
      const used = new Set(['/blogs/ratgeber']);
      const pick = (sel) => [...rg.querySelectorAll(sel)].map((s) => { const h = s.getAttribute('href'); const li = by[h]; if (!li || used.has(h)) return null; used.add(h); return prep(li, s); }).filter(Boolean);
      const allLi = by['/blogs/ratgeber'];
      prep(allLi, null); allLi.querySelector('a').insertAdjacentHTML('afterbegin', BOOK);
      const tiles = pick('a.nvrm__tile');
      const rows = pick('a.nvrm__row');
      const rest = lis.filter((li) => !used.has(hrefOf(li))).map((li) => prep(li, null));
      ul.textContent = '';
      [secB('', [allLi], 'hero'), secB('Nach Thema', tiles.concat(rest), 'tiles'), secB('Bei Medikamenten & Blutabnahme', rows, 'rows')].forEach((p) => { if (p) ul.appendChild(p); });
      const fr = document.createElement('li'); fr.className = 'nvp__sec';
      fr.innerHTML = '<a class="nvp__finder" href="/pages/kombinations-guide"><span><b>Was passt zusammen?</b><small>Kombinations-Tabelle mit Abständen</small></span><span class="nvp__go" aria-hidden="true">→</span></a>';
      ul.appendChild(fr);
      return;
    }
    if (lis.length < 6) {
      ul.classList.add('nvp--list');
      lis.forEach((li) => {
        const a = li.querySelector('a'); if (!a) return;
        const h = a.getAttribute('href'); const k = (h || '').split('?')[0].split('/').pop();
        li.classList.add('nvp__it'); a.classList.add('nvp__a');
        const ic = icon(h); if (ic) a.prepend(ic);
        const t = a.querySelector('.menu-drawer__menu-item-text');
        if (DESC[k] && t) { const s = document.createElement('small'); s.textContent = DESC[k]; t.appendChild(s); }
      });
      ul.textContent = '';
      [secB('', lis.slice(0, 1), 'hero'), secB('', lis.slice(1), 'rows')].forEach((x) => { if (x) ul.appendChild(x); });
      const pc = (href, img, eb, tx, bt) => '<a class="nvmb-d__promo nvp__promo--light" href="' + href + '"><img src="/cdn/shop/' + img + '?width=300" alt="" loading="lazy" width="208" height="236"><span class="mega-promo__body"><span class="mega-promo__eyebrow">' + eb + '</span><span class="mega-promo__text">' + tx + '</span><span class="mega-promo__button">' + bt + '</span></span></a>';
      const x = document.createElement('li'); x.className = 'nvp__sec nvp__promos';
      x.innerHTML = '<p class="nvp__h">Weiter entdecken</p>'
        + pc('/pages/produktfinder', 'files/Tea_cup_and_notebook_on_2K_20261001125845.jpg', 'Produktfinder', 'In 1 Minute herausfinden, was zu dir passt.', 'Zum Quiz →')
        + pc('/pages/tagesroutine', 'files/Friends_laughing_together_in_meadow_2K_20261001234_d4f1c278-3505-4720-9c43-e8d9e667b613.jpg', 'Tagesroutine', 'Morgens, mittags, abends: wann du was einnimmst.', 'Routine ansehen →')
        + pc('/blogs/ratgeber', 'articles/Zinc_rich_foods_flat_lay_2K_20260925022514.jpg', 'Ratgeber', 'Wissen zu Vitaminen & Mineralstoffen, verständlich erklärt.', 'Zum Ratgeber →');
      ul.appendChild(x);
      return;
    }
    const g = { all: [], ziel: [], wirk: [], form: [], sets: [] };
    const sub = { all: 'Das ganze Sortiment', sets: 'Abgestimmte Kombinationen' };
    lis.forEach((li) => {
      const a = li.querySelector('a'); if (!a) return;
      const h = a.getAttribute('href'); const k = kind(h); g[k].push(li);
      li.classList.add('nvp__it', 'nvp__it--' + k); a.classList.add('nvp__a');
      const ic = icon(h); if (ic) a.prepend(ic);
      const t = a.querySelector('.menu-drawer__menu-item-text');
      if (sub[k] && t) { const s = document.createElement('small'); s.textContent = sub[k]; t.appendChild(s); }
    });
    const sec = secB;
    const parts = [sec('', g.all, 'hero'), sec('Nach Ziel', g.ziel, 'tiles'), sec('Nach Wirkstoff', g.wirk, 'chips'), sec('Nach Form', g.form, 'tiles'), sec('', g.sets, 'hero')];
    ul.textContent = '';
    parts.forEach((p) => { if (p) ul.appendChild(p); });
    const f = document.createElement('li'); f.className = 'nvp__sec';
    f.innerHTML = '<a class="nvp__finder" href="/pages/produktfinder"><span><b>Unsicher, was passt?</b><small>Produktfinder: 1-Minuten-Test</small></span><span class="nvp__go" aria-hidden="true">→</span></a>';
    ul.appendChild(f);
  };
  const decorate = () => {
    document.querySelectorAll('.menu-drawer .menu-drawer__inner-submenu').forEach(flat);
    const caret = document.querySelector('.menu-drawer summary.menu-drawer__menu-item--mainlist .icon-caret');
    if (caret) {
      document.querySelectorAll('.menu-drawer a.menu-drawer__menu-item--mainlist').forEach((a) => { if (!a.querySelector('.icon-caret')) { a.classList.add('nvp-car'); a.appendChild(caret.cloneNode(true)); } });
      document.querySelectorAll('.nvmb-d__main .nvmb-d__chev').forEach((c) => { const n = caret.cloneNode(true); c.replaceWith(n); });
    }
    const map = {};
    document.querySelectorAll('.menu-list__submenu').forEach((s) => {
      const l = s.closest('li'); const t = l && (l.querySelector('.menu-list__link-title') || l.querySelector('a, span'));
      if (t) map[norm(t.textContent)] = s;
    });
    document.querySelectorAll('.menu-drawer a.menu-drawer__menu-item--child').forEach((a) => {
      if (a.dataset.nvi) return; a.dataset.nvi = '1';
      const d = document.querySelector('a.mega-menu__link[href="' + a.getAttribute('href') + '"] .mega-icon');
      if (d) { const c = d.cloneNode(true); c.className = 'nvmb-d__mi'; a.prepend(c); }
    });
    document.querySelectorAll('.menu-drawer details.menu-drawer__menu-container').forEach((dt) => {
      if (dt.dataset.nvp) return; dt.dataset.nvp = '1';
      const sm = dt.querySelector(':scope > summary'); const s = sm && map[norm(sm.textContent)];
      const inner = dt.querySelector('.menu-drawer__inner-submenu');
      if (!s || !inner) return;
      const ps = [...s.querySelectorAll('.mega-promo')]; if (!ps.length) return;
      const mk = (p) => { const c = p.cloneNode(true); c.className = 'nvmb-d__promo'; const img = c.querySelector('img'); if (img) { img.className = ''; img.loading = 'lazy'; img.sizes = '120px'; } return c; };
      const groups = [...inner.querySelectorAll('.menu-drawer__menu--childlist > .menu-drawer__list-item--flat')];
      if (groups.length === ps.length) {
        ps.forEach((p, i) => { const w = document.createElement('div'); w.className = 'nvmb-d__promos'; w.appendChild(mk(p)); groups[i].appendChild(w); });
      } else {
        const w = document.createElement('div'); w.className = 'nvmb-d__promos nvmb-d__promos--end'; ps.forEach((p) => w.appendChild(mk(p))); inner.appendChild(w);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate); else decorate();
  window.addEventListener('load', decorate);
  document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('#Details-menu-drawer-container > summary, .header__icon--menu')) setTimeout(decorate, 80); }, true);
})();

/* NervaraLab · Produktfinder: nach jedem Schritt nicht an den Seitenanfang springen,
   sondern nur so weit scrollen, dass die Frage-Karte unter dem Header beginnt –
   und gar nicht scrollen, wenn sie bereits gut sichtbar ist. */
(() => {
  const fix = () => {
    const root = document.getElementById('finder');
    if (!root || root.__nvqScroll) return; root.__nvqScroll = true;
    root.scrollIntoView = function () {
      const res = root.querySelector('[data-res]');
      const q = root.querySelector('[data-q]');
      const t = (res && !res.hidden) ? res : (q && !q.hidden ? q : root);
      const hd = document.querySelector('header');
      const hb = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;
      const off = hb + 12;
      const top = t.getBoundingClientRect().top;
      if (top < off || top > window.innerHeight * 0.45) {
        window.scrollTo({ top: Math.max(0, window.scrollY + top - off), behavior: 'smooth' });
      }
    };
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  window.addEventListener('load', fix);
})();